document.addEventListener('DOMContentLoaded', function() {

  // --- 1. The Single, Reusable Announcer Function ---
  // This will handle all of our HIDDEN screen reader messages.
  function announceToScreenReader(message) {
    const liveRegion = document.querySelector('#CartAnnouncer');
    if (liveRegion) {
      console.log('Hidden Announcer Fired:', message);
      liveRegion.textContent = '';
      setTimeout(() => {
        liveRegion.textContent = message;
      }, 20);
      setTimeout(() => {
        liveRegion.textContent = '';
      }, 5000);
    }
  }

  // --- 1.5. The VISIBLE Announcer Function ---
  // This handles the visible "Item Added" message and appends hidden text for screen readers.
  function setVisibleCartMessage(visibleMessage, screenReaderMessage) {
    const visibleRegion = document.querySelector('#CartDrawerAnnouncer');
    if (visibleRegion) {
      if (visibleMessage) {
        // Show the message
        console.log('Visible Announcer Fired:', visibleMessage);
        
        // Combine the visible and hidden text
        visibleRegion.innerHTML = `
          ${visibleMessage}
          <span class="visually-hidden">${screenReaderMessage}</span>
        `;
        
        visibleRegion.style.display = 'block';
        visibleRegion.focus(); // Force focus to read all content
      } else {
        // Hide the message
        console.log('Visible Announcer Cleared');
        visibleRegion.innerHTML = '';
        visibleRegion.style.display = 'none';
      }
    }
  }

  // --- 2. Consolidated Click Listener ---
  // This single listener handles adding, removing, and slider navigation.
  document.addEventListener('click', function(event) {
    
    // For adding a recommendation item
    const addBtn = event.target.closest('.cart-recommendation-add-btn');
    if (addBtn) {
      event.preventDefault();
      const productTitle = addBtn.getAttribute('data-product-title');
      
      // "Set a flag" with the details for our announcement
      sessionStorage.setItem('cartAnnouncement', `1 ${productTitle} added`);

      // The rest of your add-to-cart fetch logic
      addBtn.classList.add('loading');
      const originalText = addBtn.textContent;
      addBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: addBtn.getAttribute('data-variant-id'), quantity: 1 })
      })
      .then(r => r.json())
      .then(data => {
        addBtn.classList.remove('loading');
        addBtn.classList.add('added');
        addBtn.textContent = 'Added!';
        updateShippingProgress();
        updateCartItemCount();
        refreshCartDrawer(); // This triggers the smart announcer below
        setTimeout(() => {
          addBtn.classList.remove('added');
          addBtn.textContent = originalText;
        }, 2000);
      })
      .catch(e => {
        console.error('Error adding recommendation item:', e);
        sessionStorage.removeItem('cartAnnouncement'); // Clear flag on error
      });
    }

    // For adding an item from the main product page form
    const mainAddBtn = event.target.closest('.add-to-cart');
    if (mainAddBtn && !addBtn) { // Check if it's the main button and not the recommendation one
        // The theme handles the AJAX submission, so we don't prevent default.
        // We just need to set the flag for the announcer.
        const productForm = mainAddBtn.closest('form');
        if (!productForm) return;

        // Find the product title on the page
        const titleElement = document.querySelector('.product-single__title, .product__title h1, .product-info__title');
        const productTitle = titleElement ? titleElement.textContent.trim() : 'Item';

        // Find the quantity input
        const quantityInput = productForm.querySelector('[name="quantity"]');
        const quantityAdded = quantityInput ? parseInt(quantityInput.value, 10) : 1;

        // "Set a flag" with the details for our announcement
        sessionStorage.setItem('cartAnnouncement', `${quantityAdded} x ${productTitle} added`);

        // --- THIS IS THE FIX ---
        // Since the theme is silent, manually trigger our announcer
        // after 1.5 seconds to let the theme open the drawer.
        setTimeout(handleCartAnnouncement, 1500); 
    }

    // For removing an item via the "minus" button
    const minusButton = event.target.closest('.js-qty__adjust--minus');
    if (minusButton && minusButton.nextElementSibling.value == '1') {
      const label = minusButton.getAttribute('aria-label');
      let productTitle = 'Item';
      if (label) {
        const start = label.indexOf('of ') + 3;
        const end = label.indexOf(' to zero');
        if (start > 2 && end > start) productTitle = label.substring(start, end);
      }
      sessionStorage.setItem('cartAnnouncement', `${productTitle} has been removed from your cart.`);
    }
  });

  // --- 3. Listener for Typing "0" ---
  document.addEventListener('change', function(event) {
    const quantityInput = event.target.closest('.js-qty__num');
    if (quantityInput && parseInt(quantityInput.value, 10) === 0) {
      let productTitle = 'Item';
      const cartItem = quantityInput.closest('.cart__item');
      if (cartItem) {
        const titleElement = cartItem.querySelector('.cart__product-name');
        if (titleElement) productTitle = titleElement.textContent.trim();
      }
      sessionStorage.setItem('cartAnnouncement', `${productTitle} has been removed from your cart.`);
    }
  });

// --- 4. The "Smart" Announcer Listener ---

// We need a variable to hold our timeout, so we can clear it.
let announcerTimeout;

// Create ONE function to handle the announcement
function handleCartAnnouncement() {
  // Clear any *previous* scheduled announcement. This is the debounce.
  clearTimeout(announcerTimeout);
  
  // Schedule a *new* announcement.
  announcerTimeout = setTimeout(() => {
    
    // ALWAYS hide the visible message on every cart update.
    setVisibleCartMessage(null); // Pass null to hide it
    
    const message = sessionStorage.getItem('cartAnnouncement');
    
    if (message) {
      if (message.includes('removed')) {
        // "Removed" messages go to the HIDDEN announcer
        announceToScreenReader(message);
      } else {
        // "Added" messages go to the VISIBLE announcer
        
        // This is the simple, visible part. We add a period for a pause.
        const visibleMessage = message + '.'; 

        fetch('/cart.js').then(r => r.json()).then(cart => {
          
          // --- THIS IS THE NEW LOGIC ---
          // We'll build an array of messages, then join them.
          let screenReaderParts = [];
          
          // Part 1: Total
          screenReaderParts.push(`Total items in cart: ${cart.item_count}`);
          
          // Part 2: Shipping message text
          const shippingContainer = document.querySelector('[data-free-shipping-message]');
          if (shippingContainer) {
            const shippingTextElement = shippingContainer.querySelector('span, div');
            if (shippingTextElement) {
              // Get text and clean it up
              let shippingText = shippingTextElement.textContent.replace(/(\r\n|\n|\r)/gm, " ").replace(/\s+/g, ' ').trim();
              // Remove any trailing punctuation (like '!' or '.') so we can add our own
              shippingText = shippingText.replace(/[.,!]$/, ''); 
              screenReaderParts.push(shippingText);
            }
          }

          // Part 3: Subtotal text
          const subtotalElement = document.querySelector('[data-subtotal]');
          if (subtotalElement) {
            screenReaderParts.push(`Subtotal: ${subtotalElement.textContent.trim()}`);
          }

          // Join all hidden parts with a period and a space.
          // This creates the pauses: "Part 1. Part 2. Part 3."
          const screenReaderMessage = screenReaderParts.join('. ');

          // Send BOTH messages to the function
          setVisibleCartMessage(visibleMessage, screenReaderMessage); 
        });
      }
      sessionStorage.removeItem('cartAnnouncement'); // Clear the flag
    } else {
      // No flag was set (e.g., just opened, or last item removed)
      fetch('/cart.js').then(r => r.json()).then(cart => {
        if (cart.item_count === 0) {
          announceToScreenReader("Your cart is currently empty."); // Use hidden
        }
      });
    }
  }, 750); // Wait 750ms for the refresh chaos to settle.
}

// Now, listen for ALL cart events (this is unchanged)
document.addEventListener('cart:refreshed', handleCartAnnouncement); 
document.addEventListener('cart:updated', handleCartAnnouncement); 
document.addEventListener('ajax:cart:updated', handleCartAnnouncement);

  // --- 5. Your Original Helper Functions ---
  
  const sliderNav = document.querySelector('.cart-recommendations-slider-nav');
  if (sliderNav) {
    sliderNav.addEventListener('click', function(event) {
      event.stopPropagation();
      const slider = document.querySelector('.cart-recommendations-slider');
      if (event.target.classList.contains('cart-recommendation-prev')) {
        event.preventDefault();
        slider.scrollBy({ left: -200, behavior: 'smooth' });
      } else if (event.target.classList.contains('cart-recommendation-next')) {
        event.preventDefault();
        slider.scrollBy({ left: 200, behavior: 'smooth' });
      }
    });
  }
  
  function updateCartItemCount() {
    fetch('/cart.js').then(response => response.json()).then(cart => {
      const itemCountElements = document.querySelectorAll('[data-cart-count]');
      itemCountElements.forEach(element => {
        element.textContent = cart.item_count;
        if (cart.item_count > 0 && element.classList.contains('hide')) {
          element.classList.remove('hide');
        }
      });
    }).catch(error => console.error('Error updating cart count:', error));
  }
  
  function refreshCartDrawer() {
    fetch('/?sections=cart-drawer').then(response => response.json()).then(sections => {
      const parser = new DOMParser();
      const newDrawerContent = parser.parseFromString(sections['cart-drawer'], 'text/html');
      const currentDrawer = document.getElementById('CartDrawer');
      if (currentDrawer) {
        updateCartSection(currentDrawer, newDrawerContent, '[data-products]');
        updateCartSection(currentDrawer, newDrawerContent, '[data-subtotal]');
        updateCartSection(currentDrawer, newDrawerContent, '.cart-recommendations-slider');
        const emptyCartElement = currentDrawer.querySelector('.drawer__cart-empty');
        if (emptyCartElement && !emptyCartElement.classList.contains('hide')) {
          emptyCartElement.classList.add('hide');
        }
      }
      initializeRecommendationsSlider();
      updateShippingProgress();
      document.dispatchEvent(new CustomEvent('cart:refreshed'));
    }).catch(error => console.error('Error refreshing cart drawer:', error));
  }
  
  function updateCartSection(currentDrawer, newDrawerContent, selector) {
    const currentSection = currentDrawer.querySelector(selector);
    const newSection = newDrawerContent.querySelector(selector);
    if (currentSection && newSection) {
      currentSection.innerHTML = newSection.innerHTML;
    }
  }

  function initializeRecommendationsSlider() {
    const slider = document.querySelector('.cart-recommendations-slider');
    if (slider) {
      const sliderNavButtons = document.querySelectorAll('.cart-recommendation-prev, .cart-recommendation-next');
      sliderNavButtons.forEach(button => {
        const newButton = button.cloneNode(true);
        if (button.parentNode) {
          button.parentNode.replaceChild(newButton, button);
        }
      });
    }
  }

  function updateShippingProgress() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const FREE_SHIPPING_THRESHOLD = 6000;
        const container = document.querySelector('[data-free-shipping-message]');
        if (!container) return;

        const cartTotal = cart.total_price;
        const remainingAmount = FREE_SHIPPING_THRESHOLD - cartTotal;
        const progressPercentage = Math.min(100, (cartTotal / FREE_SHIPPING_THRESHOLD) * 100);
        
        container.innerHTML = ''; 

        if (cartTotal >= FREE_SHIPPING_THRESHOLD) {
          const itemCount = cart.item_count;
          container.innerHTML = `
            <div class="cart-drawer__free-shipping-qualified">
              <div>🎉 Congratulations! You qualify for free shipping!<span class="visually-hidden" role="status" aria-live="assertive">You have ${itemCount} items in your cart.</span></div>
            </div>`;
        } else {
          let formattedAmount = (remainingAmount / 100).toFixed(2).replace('.00', '');
          const itemCount = cart.item_count;
          container.innerHTML = `
            <div class="cart-drawer__free-shipping-threshold">
              <span>Spend <strong>$${formattedAmount}</strong> more and get free shipping!</span>
              <div class="cart-drawer__progress-container">
                <div class="cart-drawer__progress-bar" 
                     role="progressbar"
                     style="width: ${progressPercentage}%"
                     aria-valuenow="${progressPercentage.toFixed(0)}"
                     aria-valuemin="0"
                     aria-valuemax="100"
                     aria-label="currently ${itemCount} items in your cart">
                </div>
              </div>
            </div>`;
        }
      })
      .catch(error => console.error('Error updating shipping. progress:', error));
  }
  
  document.addEventListener('cart:update', function(event) {
    updateShippingProgress();
    updateCartItemCount();
  });
  
  const cartProductsContainer = document.querySelector('[data-products]');
  if (cartProductsContainer) {
    const observer = new MutationObserver(function(mutations) {
      updateShippingProgress();
      updateCartItemCount();
    });
    observer.observe(cartProductsContainer, { childList: true, subtree: true });
  }
  
  updateShippingProgress();
  updateCartItemCount();
  initializeRecommendationsSlider();
  
  window.refreshCart = function() {
    refreshCartDrawer();
  };
});